<template>
  <div class="pe-semester-serial-editor">
    <el-select :loading="loading"
               loading-text="学期顺序加载中..."
               filterable
               clearable
               v-bind="$attrs"
               v-on="$listeners">
      <template v-if="serials">
        <el-option v-for="serial in serials"
                   :key="serial.id"
                   :label="serial.name"
                   :value="serial.id"></el-option>
      </template>
    </el-select>
  </div>
</template>

<script>
export default {
  name: 'PeSemesterSerialEditor',
  data () {
    return {
      loading: false,
      serials: null
    }
  },
  methods: {
    loadSerials () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/basic/peSemester/serials',
        method: 'post'
      }).then(response => {
        if (response.data) {
          this.serials = response.data.serials || []
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    }
  },
  mounted () {
    this.loadSerials()
  }
}
</script>

<style lang="scss">
  .pe-semester-serial-editor {
    .el-select {
      width: 100%;
    }
  }
</style>
